import React from 'react'

import { AdminBorrowerWithdrawalsFlexList } from '@react/admin/AdminBorrowerWithdrawalsFlexList'
import BorrowerAdminWithdrawFlexLedger from './BorrowerAdminWithdrawFlexLedger'

export const BorrowerWithdrawalFlexTab = () => {
  return (
    <>
      <AdminBorrowerWithdrawalsFlexList />
      <BorrowerAdminWithdrawFlexLedger />
    </>
  )
}
